import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  TPlatformAgreementDetails,
  TPlatformUseGetData,
} from "../types/customers";
export type CashLimitData = {
  value: string;
};
export type FinancePartnerInfo = {
  id?: number;
  finPartnerId: number;
  finPartnerName: string;
  status?: number;
  isMapped?: boolean;
  partnerAuthName?: string;
  mobile?: string;
  emailId?: string;
  agreements: TPlatformUseGetData[];
  canInitiateAgreement?: boolean;
  limit?: number;
  utilisedLimit?: number;
  initiateKyc?: boolean;
  kycUrl?: string;
  kycStatus?: string;
  kycInitiateDate?: string;
  kycEndDate?: string;
};
type TinitialState = {
  partners: FinancePartnerInfo[];
  unmappedPartners: FinancePartnerInfo[];
  cashLimits: Record<number, CashLimitData>;
  cashLimitEditingPartnerId: number | null;
  cashLimitEditingId: number | null;
};
const initialState: TinitialState = {
  partners: [],
  unmappedPartners: [],
  cashLimits: {},
  cashLimitEditingPartnerId: null,
  cashLimitEditingId: null,
};
const financePartnerSlice = createSlice({
  name: "financePartnerSlice",
  initialState: initialState,
  reducers: {
    setPartnersInfo: (state, action: PayloadAction<FinancePartnerInfo[]>) => {
      state.partners = action.payload;
    },
    updateUnmappedPartners: (
      state,
      action: PayloadAction<FinancePartnerInfo[]>,
    ) => {
      state.unmappedPartners = action.payload;
    },
    updatePartnerAgreements: (
      state,
      action: PayloadAction<{
        partnerInfo: FinancePartnerInfo;
        agreements: TPlatformUseGetData[];
      }>,
    ) => {
      const partner = state.partners.find(
        (item) => item.finPartnerId === action.payload.partnerInfo.finPartnerId,
      );

      if (partner) {
        partner.agreements = action.payload.agreements;
      }
    },
    setCashLimitEditingPartner: (
      state,
      action: PayloadAction<{
        finPartnerId: number;
        partnerId?: number;
      } | null>,
    ) => {
      state.cashLimitEditingPartnerId = action.payload?.finPartnerId ?? null;
      state.cashLimitEditingId = action.payload?.partnerId ?? null;
    },
    setFinPartnerCashLimit: (
      state,
      action: PayloadAction<{
        partnerId: number;
        value: string;
      }>,
    ) => {
      const { partnerId, value } = action.payload;
      state.cashLimits[partnerId] = {
        value,
      };
    },

    clearCashLimitEditing: (state) => {
      state.cashLimitEditingPartnerId = null;
      state.cashLimits = {};
      state.cashLimitEditingId = null;
    },
  },
});

export const {
  setPartnersInfo,
  updateUnmappedPartners,
  updatePartnerAgreements,
  setCashLimitEditingPartner,
  setFinPartnerCashLimit,
  clearCashLimitEditing,
} = financePartnerSlice.actions;
export default financePartnerSlice.reducer;
